import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.is-array";
export default function isOneOf(one, ofTarget) {
  if (Array.isArray(ofTarget)) {
    return ofTarget.indexOf(one) >= 0;
  }

  return one === ofTarget;
}